import api from './api';

export const validateInvitation = async (token) => {
  const response = await api.get(`/invitations/${token}`);
  return response.data;
};

export const acceptInvitation = async (token, userData) => {
  const response = await api.post(`/invitations/${token}/accept`, userData);
  return response.data;
};